import { useEffect } from "react";

// Photos tagged "pending" are being upscaled behind the scenes; the record
// swaps to the HD copy once the model finishes, so callers poll until it lands.
export const hasPendingHd = (photos) =>
  (photos || []).some((p) => p?.enhance_status === "pending");

export const usePendingHdRefresh = (pending, reload, ms = 4000) => {
  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(reload, ms);
    return () => clearInterval(t);
  }, [pending, reload, ms]);
};

export const HD_STATUS_LABEL = {
  pending: "Enhancing…",
  failed: "HD failed",
  skipped: "HD skipped",
};
